var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filial-badge"},[_c('font-awesome-icon',{staticClass:"filial-badge__icon",attrs:{"icon":"store"}}),_c('div',{staticClass:"filial-badge__value"},[_vm._v(" "+_vm._s(_vm.name || 'Филиал не выбран')+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }